import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function LockFilled({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 12 12"
    >
      <Path
        d="M3.77107 2.22222C3.77107 0.99492 4.76599 0 5.99329 0C7.22059 0 8.21553 0.99492 8.21553 2.22222V4.00002H10.4373C10.9282 4.00002 11.3266 4.39799 11.3266 4.88935V11.1107C11.3266 11.6022 10.9281 12 10.4373 12H1.5493C1.05833 12 0.659973 11.602 0.659973 11.1107V4.88935C0.659973 4.39782 1.0585 4.00002 1.5493 4.00002H3.77107V2.22222ZM5.99319 6.6665C5.50227 6.6665 5.10431 7.06447 5.10431 7.55539V8.4443C5.10431 8.9352 5.50227 9.3332 5.99319 9.3332C6.48411 9.3332 6.88208 8.9352 6.88208 8.4443V7.55539C6.88208 7.06447 6.48411 6.6665 5.99319 6.6665ZM7.32663 3.9998V2.222C7.32663 1.48562 6.72968 0.88867 5.9933 0.88867C5.25692 0.88867 4.65997 1.48562 4.65997 2.222V3.9998H7.32663Z"
        fill={iconColor}
      />
    </Svg>
  );
}
